











import {Component, Vue} from "vue-property-decorator";
import axios from "axios";

@Component({})
export default class Logout extends Vue {
    public created() {
        // does not really delete cookie
        // TODO
        axios.delete(process.env.VUE_APP_ROOT_API + "/token", {
            withCredentials: true, params: {
                hue: "lmao",
            },
        }).then((res) => {
            // console.log(res);
        });
        localStorage.removeItem("auth_xsrf");
        localStorage.removeItem("auth_expires");
        localStorage.removeItem("auth_refresh");
    }

    protected loginAgain(evt: MouseEvent) {
        window.location.pathname = "/login";
    }

    protected viewCalendar(evt: MouseEvent) {
        window.location.pathname = "/";
    }
}
